import styled from 'styled-components';

export const SignatureSuccess = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	background-color: white;

	@media only screen and (min-width: 601px) {
		background-color: #F5F5F5;
	}
`;

SignatureSuccess.Container = styled.div`
	padding: 32px 16px 16px;

	@media only screen and (min-width: 601px) {
		max-width: 600px;
		background-color: white;
		margin: 2rem auto;
		padding: 32px;
		border-radius: 16px;
	}
`;

SignatureSuccess.HeaderTitle = styled.p`
	font-weight: 700;
	font-size: 20px;
	color: #26282A;
	margin: 0 0 8px;
	line-height: 1.3;
`;

SignatureSuccess.HeaderSubtitle = styled.p`
	font-weight: 400;
	font-size: 14px;
	color: #4E5255;
	margin: 0;
	line-height: 1.4;
`;

SignatureSuccess.ImageSuccess = styled.img`
	width: 160px;
	height: auto;
`;

SignatureSuccess.Title = styled.p`
	font-weight: 600;
	font-size: 22px;
	text-align: center;
	color: #26282A;
	line-height: 1.3;
	margin: 12px 0 8px;
`;

SignatureSuccess.Text = styled.p`
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	color: #4E5255;
	line-height: 1.4;
	margin: 0;
`;

SignatureSuccess.SignatureContainer = styled.div`
	min-height: 104px;
	border: 1px dashed #D9E1E8;
	border-radius: 12px;
	background-color: #FAFBFC;
`;

SignatureSuccess.SignatureBox = styled.img`
	width: 180px;
	height: 80px;
	object-fit: contain;
`;

SignatureSuccess.UserContainer = styled.div`
	padding: 8px 0 24px;
	text-align: center;
`;

SignatureSuccess.UserName = styled.p`
	word-break: break-all;
	font-weight: 600;
	font-size: 18px;
	text-align: center;
	color: #26282A;
	line-height: 1.3;
	margin: 0 0 6px;
`;

SignatureSuccess.Cpf = styled.p`
	font-weight: 400;
	font-size: 16px;
	color: #4E5255;
	line-height: 20px;
	text-align: center;
`;

SignatureSuccess.Footer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: flex-end;
`;

SignatureSuccess.Button = styled.button`
	color: #26282A;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	height: 50px;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	background-color: white;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover:not(:disabled) {
		background-color: #F5F5F5;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

SignatureSuccess.ButtonText = styled.span`
	font-size: 16px;
	font-weight: 500;
`;
